var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _vm.isAdding && !_vm.isStudentSelected
        ? _c("search-references", { on: { onSelect: _vm.onSelectStudent } })
        : _vm._e(),
      (_vm.isAdding && _vm.isStudentSelected) || _vm.isDetailsView
        ? _c(
            "div",
            [_c("historial-umers", { attrs: { student: _vm.student } })],
            1
          )
        : _vm._e(),
      (_vm.isAdding && _vm.isStudentSelected) || _vm.isDetailsView
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c(
                "validation-observer",
                { ref: "umers" },
                [
                  _c("general-info", {
                    ref: "generalInfo",
                    attrs: { data: _vm.records, disabled: _vm.readOnly },
                    on: { change: _vm.onChangeGeneralInfo }
                  }),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("documents", {
                        attrs: {
                          "auto-upload": _vm.isDetailsView,
                          "available-document-types": _vm.documentTypes,
                          disabled: _vm.readOnly,
                          "on-download": this.onDownload,
                          "unique-document-type": true
                        },
                        on: {
                          isValid: _vm.isDocumentValid,
                          onRemove: _vm.onRemoveDocuments,
                          onUpload: _vm.editionDocumentsUpload
                        },
                        model: {
                          value: _vm.documents,
                          callback: function($$v) {
                            _vm.documents = $$v
                          },
                          expression: "documents"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }